// extracted by mini-css-extract-plugin
export default {"access":"access_access__r47Y5"};